/**
 * Column Statistics Service
 * Fetches descriptive statistics for data columns
 */
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002/api/v1';

export interface TopValue {
  value: string;
  count: number;
  percentage: number;
}

export interface DistributionCategory {
  name: string;
  percentage: number;
}

export interface DistributionRange {
  range: string;
  count: number;
  percentage: number;
}

export interface ColumnStatistics {
  columnName: string;
  dataType: string;
  tableName: string;
  totalRecords: number;
  populatedRecords: number;
  nullRecords: number;
  completeness: number;
  uniqueValues: number | null;
  topValues?: TopValue[];
  distribution?: {
    categories?: DistributionCategory[];
    ranges?: DistributionRange[];
    decades?: DistributionRange[];
  };
  // Numeric fields
  min?: number;
  max?: number;
  mean?: number;
  median?: number;
  mode?: number;
  stdDev?: number;
  quartiles?: {
    q1: number;
    q2: number;
    q3: number;
  };
  // Text fields
  avgLength?: number;
  minLength?: number;
  maxLength?: number;
  // Date fields
  minDate?: string;
  maxDate?: string;
  mostCommonYear?: number;
}

/**
 * Get statistics for a column
 */
export const getColumnStatistics = async (
  columnName: string,
  dataType: string,
  tableName: string
): Promise<ColumnStatistics> => {
  const token = localStorage.getItem('token');
  
  const response = await axios.get(`${API_BASE_URL}/column-statistics`, {
    params: {
      columnName,
      dataType,
      tableName
    },
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  
  return response.data;
};

export default {
  getColumnStatistics
};
